<div class="one" fxLayout="column" [formGroup]="matterdetailForm">
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.REFERENCE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.REFERENCE),
      }"
    >
      <mat-label>Client Reference</mat-label>
      <input
        name="ClientReference"
        formControlName="REFERENCE"
        matInput
        matTooltip="{{ toolTipList ? toolTipList.REFERENCE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      @if (testBool && toolTipList.REFERENCE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.REFERENCE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.REFERENCE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.OTHERREFERENCE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.OTHERREFERENCE),
      }"
    >
      <mat-label>Other Ref</mat-label>
      <input
        matInput
        formControlName="OTHERREFERENCE"
        matTooltip="{{ toolTipList ? toolTipList.OTHERREFERENCE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      @if (testBool && toolTipList.OTHERREFERENCE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.OTHERREFERENCE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.OTHERREFERENCE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
      <mat-icon matSuffix class="secondary-text"></mat-icon>
    </mat-form-field>
    <!-- <mat-form-field appearance="outline" class="example" fxFlex="34" class="pr-1" [ngClass]="{'has-error':errorWarningData.Error?.MATTERSTATUS,'has-warning':errorWarningData.Warning?.MATTERSTATUS }">
        <mat-label>Matter Status</mat-label>
        <mat-select formControlName="MATTERSTATUS">
          <mat-option *ngFor="let MatterStatusLookup of MatterStatusLookupsData" value="{{MatterStatusLookup.LOOKUPFULLVALUE}}">
          {{MatterStatusLookup.LOOKUPFULLVALUE}}</mat-option>
        </mat-select>
      </mat-form-field> -->
    <mat-form-field
      appearance="outline"
      class="example"
      fxFlex="34"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.MATTERSTATUS),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.MATTERSTATUS),
      }"
    >
      <mat-label>Matter Status</mat-label>
      <input
        type="text"
        placeholder="Matter Status"
        matInput
        name="MATTERSTATUS"
        formControlName="MATTERSTATUS"
        [matAutocomplete]="auto2"
        matTooltip="{{ toolTipList ? toolTipList.MATTERSTATUS?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      @if (testBool && toolTipList.MATTERSTATUS) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.MATTERSTATUS.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.MATTERSTATUS?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
      <mat-autocomplete #auto2="matAutocomplete">
        @for (MatterStatusLookup of MatterStatusLookupsData; track MatterStatusLookup) {
          <mat-option value="{{ MatterStatusLookup.LOOKUPFULLVALUE }}">
            {{ MatterStatusLookup.LOOKUPFULLVALUE }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      class="example"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.COMMENCEMENTDATE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.COMMENCEMENTDATE),
      }"
    >
      <mat-label>Commencement Date</mat-label>
      <input
        (dateInput)="CommencementDate('input', $event)"
        formControlName="DATETEXT"
        (dateChange)="CommencementDate('change', $event)"
        matInput
        [matDatepicker]="picker1"
        matTooltip="{{ toolTipList ? toolTipList.DATEEXECUTED?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
      <mat-datepicker #picker1></mat-datepicker>
      @if (testBool && toolTipList.DATEEXECUTED) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.DATEEXECUTED.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.DATEEXECUTED?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      class="example"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.DUEDATE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.DUEDATE),
      }"
    >
      <mat-label>Due Date</mat-label>
      <input
        (dateInput)="DueDate('input', $event)"
        formControlName="DUEDATEForm"
        (dateChange)="DueDate('change', $event)"
        matInput
        [matDatepicker]="picker4"
        matTooltip="{{ toolTipList ? toolTipList.DUEDATE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
      <mat-datepicker #picker4></mat-datepicker>
      @if (testBool && toolTipList.DUEDATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.DUEDATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.DUEDATE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <!-- <mat-form-field appearance="outline" class="example" fxFlex="33" class="pr-1" [ngClass]="{'has-error':errorWarningData.Error?.FEEAGREEMENTDATE,'has-warning':errorWarningData.Warning?.FEEAGREEMENTDATE}">
        <mat-label>Costs Agreement Date</mat-label>
        <input (dateInput)="CostsAgreementDate('input', $event)" formControlName="FeeAgreementDateText" (dateChange)="CostsAgreementDate('change', $event)" matInput name="CostsAgreementDate" [matDatepicker]="picker2" matTooltip="{{(toolTipList)?toolTipList.FEEAGREEMENTDATE:''}}" [matTooltipPosition]="toolTipPostion">
        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
        <mat-datepicker #picker2></mat-datepicker>
      </mat-form-field> -->
    <mat-form-field
      appearance="outline"
      class="example"
      fxFlex="34"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.COMPLETEDDATE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.COMPLETEDDATE),
      }"
    >
      <mat-label>Completed Date</mat-label>
      <input
        (dateInput)="CompletedDate('input', $event)"
        formControlName="COMPLETEDDATETEXT"
        (dateChange)="CompletedDate('change', $event)"
        matInput
        name="CompletedDate"
        [matDatepicker]="picker3"
        matTooltip="{{ toolTipList ? toolTipList.COMPLETEDDATE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
      <mat-datepicker #picker3></mat-datepicker>
      @if (testBool && toolTipList.COMPLETEDDATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.COMPLETEDDATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.COMPLETEDDATE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      class="example"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.FEEAGREEMENTDATE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.FEEAGREEMENTDATE),
      }"
    >
      <mat-label>Costs Agreement Date</mat-label>
      <input
        (dateInput)="CostsAgreementDate('input', $event)"
        formControlName="FeeAgreementDateText"
        (dateChange)="CostsAgreementDate('change', $event)"
        matInput
        name="CostsAgreementDate"
        [matDatepicker]="picker2"
        matTooltip="{{ toolTipList ? toolTipList.FEEAGREEMENTDATE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
      <mat-datepicker #picker2></mat-datepicker>
      @if (testBool && toolTipList.FEEAGREEMENTDATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.FEEAGREEMENTDATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.FEEAGREEMENTDATE?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      class="example"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.FEEAGREEMENTRECEIVEDDATE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.FEEAGREEMENTRECEIVEDDATE),
      }"
    >
      <mat-label>Cost Agr. Rec'd</mat-label>
      <input
        (dateInput)="Costagrpicker('input', $event)"
        (dateChange)="Costagrpicker('change', $event)"
        name="costagrpicker"
        matInput
        [matDatepicker]="costagrpicker"
        formControlName="FEEAGREEMENTRECEIVEDDATETEXT"
        matTooltip="{{ toolTipList ? toolTipList.FEEAGREEMENTRECEIVEDDATE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      <mat-datepicker-toggle matSuffix [for]="costagrpicker"></mat-datepicker-toggle>
      <mat-datepicker #costagrpicker></mat-datepicker>
      @if (testBool && toolTipList.FEEAGREEMENTRECEIVEDDATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.FEEAGREEMENTRECEIVEDDATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.FEEAGREEMENTRECEIVEDDATE?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      class="example"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.LASTREVIEWDATE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.LASTREVIEWDATE),
      }"
    >
      <mat-label>Last Review Date</mat-label>
      <input
        (dateInput)="LastReviewpicker('input', $event)"
        (dateChange)="LastReviewpicker('change', $event)"
        name="lastreviewpicker"
        matInput
        [matDatepicker]="lastreviewpicker"
        formControlName="LASTREVIEWDATETEXT"
        matTooltip="{{ toolTipList ? toolTipList.LASTREVIEWDATE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      <mat-datepicker-toggle matSuffix [for]="lastreviewpicker"></mat-datepicker-toggle>
      <mat-datepicker #lastreviewpicker></mat-datepicker>
      @if (testBool && toolTipList.LASTREVIEWDATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.LASTREVIEWDATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.LASTREVIEWDATE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <!-- <mat-form-field appearance="outline" class="example" fxFlex="34" class="pr-1" [ngClass]="{'has-error':errorWarningData.Error?.MATTERSTATUS,'has-warning':errorWarningData.Warning?.MATTERSTATUS }">
      <mat-label>Matter Status</mat-label>
      <mat-select formControlName="MATTERSTATUS">
        <mat-option *ngFor="let MatterStatusLookup of MatterStatusLookupsData" value="{{MatterStatusLookup.LOOKUPFULLVALUE}}">
        {{MatterStatusLookup.LOOKUPFULLVALUE}}</mat-option>
      </mat-select>
    </mat-form-field> -->
  </div>
  @if (userType) {
    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
      <mat-form-field
        appearance="outline"
        class="example"
        fxFlex="33"
        class="pr-1"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.OwnerGuid),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.OwnerGuid),
        }"
      >
        <mat-label>Matter Owner</mat-label>
        <input
          matInput
          readonly
          formControlName="OWNERNAME"
          matTooltip="{{ toolTipList ? toolTipList.OWNERNAME?.HOVER : '' }}"
          [matTooltipPosition]="toolTipPostion"
        />
        @if (testBool && toolTipList.OWNERNAME) {
          <div class="tooltip-wrap">
            <input
              id="myInput"
              readonly
              disabled
              value="{{ toolTipList ? toolTipList.OWNERNAME.COPYVALUE : '' }}"
            />
            <mat-icon
              (click)="
                tooltipService.copyTooltipText(
                  toolTipList ? $safeNavigationMigration(toolTipList?.OWNERNAME?.COPYVALUE) : ''
                )
              "
            >
              file_copy
            </mat-icon>
          </div>
        }
        <mat-icon matSuffix (click)="selectMatter()">
          <!-- <img src="assets/icons/web_app/icon_contact_d.ico" matTooltip="Matter Owner" matTooltipPosition="above"> -->
          <!-- <img matTooltip="Matter Owner" matTooltipPosition="above" *ngIf="currentUser?.THEMECOLOUR == 'theme-default'" src="assets/icons/web_app/Contact Base Icon 1.svg">
          <img matTooltip="Matter Owner" matTooltipPosition="above" *ngIf="currentUser?.THEMECOLOUR == 'theme-yellow-light'" src="assets/icons/web_app/Contact Base Icon 1.svg">
          <img matTooltip="Matter Owner" matTooltipPosition="above" *ngIf="currentUser?.THEMECOLOUR == 'theme-blue-gray-dark'" src="assets/icons/web_app/Contact Base Icon 2.svg">
          <img matTooltip="Matter Owner" matTooltipPosition="above" *ngIf="currentUser?.THEMECOLOUR == 'theme-pink-dark'" src="assets/icons/web_app/Contact Base Icon 2.svg"> -->
          <img class="owner-radius-500" src="assets/images/avatars/Velazquez.jpg" />
        </mat-icon>
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        class="example"
        fxFlex="33"
        class="pr-1"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.PrimaryFeeEarnerGuid),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PrimaryFeeEarnerGuid),
        }"
      >
        <mat-label>Primary Fee Earner</mat-label>
        <input
          matInput
          readonly
          formControlName="PRIMARYFEEEARNERNAME"
          matTooltip="{{ toolTipList ? toolTipList.PRIMARYFEEEARNERNAME : '' }}"
          [matTooltipPosition]="toolTipPostion"
        />
        @if (testBool && toolTipList.OWNERNAME) {
          <div class="tooltip-wrap">
            <input
              id="myInput"
              readonly
              disabled
              value="{{ toolTipList ? toolTipList.OWNERNAME.COPYVALUE : '' }}"
            />
            <mat-icon
              (click)="
                tooltipService.copyTooltipText(
                  toolTipList ? $safeNavigationMigration(toolTipList?.OWNERNAME?.COPYVALUE) : ''
                )
              "
            >
              file_copy
            </mat-icon>
          </div>
        }
        <mat-icon matSuffix (click)="selectFeeEarner()">
          <!-- <img src="assets/icons/web_app/icon_contact_d.ico" matTooltip="Primary Fee Earner" matTooltipPosition="above"> -->
          <!-- <img matTooltip="Primary Fee Earner" matTooltipPosition="above" *ngIf="currentUser?.THEMECOLOUR == 'theme-default'" src="assets/icons/web_app/Contact Base Icon 1.svg">
          <img matTooltip="Primary Fee Earner" matTooltipPosition="above" *ngIf="currentUser?.THEMECOLOUR == 'theme-yellow-light'" src="assets/icons/web_app/Contact Base Icon 1.svg">
          <img matTooltip="Primary Fee Earner" matTooltipPosition="above" *ngIf="currentUser?.THEMECOLOUR == 'theme-blue-gray-dark'" src="assets/icons/web_app/Contact Base Icon 2.svg">
          <img matTooltip="Primary Fee Earner" matTooltipPosition="above" *ngIf="currentUser?.THEMECOLOUR == 'theme-pink-dark'" src="assets/icons/web_app/Contact Base Icon 2.svg"> -->
          <img class="owner-radius-500" src="assets/images/avatars/Velazquez.jpg" />
        </mat-icon>
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        class="example"
        fxFlex="34"
        class="pr-1"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.ASSISTANTGUID),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.ASSISTANTGUID),
        }"
      >
        <mat-label>Person Assisting</mat-label>
        <input
          matInput
          readonly
          formControlName="ASSISTANTNAME"
          matTooltip="{{ toolTipList ? toolTipList.ASSISTANTNAME?.HOVER : '' }}"
          [matTooltipPosition]="toolTipPostion"
        />
        @if (testBool && toolTipList.ASSISTANTNAME) {
          <div class="tooltip-wrap">
            <input
              id="myInput"
              readonly
              disabled
              value="{{ toolTipList ? toolTipList.ASSISTANTNAME.COPYVALUE : '' }}"
            />
            <mat-icon
              (click)="
                tooltipService.copyTooltipText(
                  toolTipList ? $safeNavigationMigration(toolTipList?.ASSISTANTNAME?.COPYVALUE) : ''
                )
              "
            >
              file_copy
            </mat-icon>
          </div>
        }
        <mat-icon matSuffix (click)="selectPersonAssist()">
          <!-- <img src="assets/icons/web_app/icon_contact_d.ico" matTooltip="Person Assisting" matTooltipPosition="above"> -->
          <!-- <img matTooltip="Person Assisting" matTooltipPosition="above" *ngIf="currentUser?.THEMECOLOUR == 'theme-default'" src="assets/icons/web_app/Contact Base Icon 1.svg">
          <img matTooltip="Person Assisting" matTooltipPosition="above" *ngIf="currentUser?.THEMECOLOUR == 'theme-yellow-light'" src="assets/icons/web_app/Contact Base Icon 1.svg">
          <img matTooltip="Person Assisting" matTooltipPosition="above" *ngIf="currentUser?.THEMECOLOUR == 'theme-blue-gray-dark'" src="assets/icons/web_app/Contact Base Icon 2.svg">
          <img matTooltip="Person Assisting" matTooltipPosition="above" *ngIf="currentUser?.THEMECOLOUR == 'theme-pink-dark'" src="assets/icons/web_app/Contact Base Icon 2.svg"> -->
          <img class="owner-radius-500" src="assets/images/avatars/Velazquez.jpg" />
        </mat-icon>
      </mat-form-field>
    </div>
  }
  <div
    fxLayout="row"
    fxLayoutAlign="start center"
    fxFlex="1 0 auto"
    [ngClass]="SECURITYOPTION ? 'pb-4' : 'pb-20'"
  >
    <!-- *ngIf="'' | productType" -->
    <mat-checkbox
      [(ngModel)]="SECURITYOPTION"
      formControlName="SECURITYOPTION"
      fxFlex="50"
      class="align-slef-baseline"
      (click)="matterAccessTier.ALLOWED !== 1 ? goTo(matterAccessTier.URL) : true"
      (click)="(matterAccessTier.ALLOWED !== 1 ? false : true)"
      [matTooltip]="
        ('Matter Access' | tierPermission: 'Matter Access').ALLOWED !== 1
          ? ('Matter Access' | tierPermission: 'Matter Access').DESCRIPTION
          : ''
      "
      matTooltipPosition="above"
    >
      Restrict Access to this Matter
      @if (('Matter Access' | tierPermission: 'Matter Access').ALLOWED !== 1) {
        <img src="assets/icons/web_app/Feature_is_Locked.ico" class="feature_locked_text" />
      }
    </mat-checkbox>
    <mat-form-field class="example" appearance="outline" fxFlex="50">
      <mat-label>Tick Users that should have access</mat-label>
      <mat-select
        (selectionChange)="MatterUserChange($event.value)"
        formControlName="MATTERACCESSLIST"
        multiple
        [disabled]="!SECURITYOPTION"
      >
        <!-- <mat-option value="all">All</mat-option>
        <mat-option value="">None</mat-option> -->
        @for (MatterDrop of MatterDropData; track MatterDrop) {
          <mat-option value="{{ MatterDrop.USERGUID }}">
            {{ MatterDrop.USERID }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      class="example"
      fxFlex="59"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.ESTIMATEFROMTOTALEXGST),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.ESTIMATEFROMTOTALEXGST),
      }"
    >
      <mat-label>Estimate Minimum Ex-GST</mat-label>
      <input
        currencyMask
        class="sideText"
        matInput
        type="text"
        formControlName="ESTIMATEFROMTOTALEXGST"
        (keyup)="calcPE('min')"
        [(ngModel)]="PRICEVAL"
        matTooltip="{{ toolTipList ? toolTipList.ESTIMATEFROMTOTALEXGST?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      <!-- <span class="currency_sign" matPrefix>$&nbsp;</span> -->
      @if (testBool && toolTipList.ESTIMATEFROMTOTALEXGST) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.ESTIMATEFROMTOTALEXGST.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.ESTIMATEFROMTOTALEXGST?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="50"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.PRICEVALGST),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PRICEVALGST),
      }"
    >
      <mat-label>Estimate Minimum Inc-GST</mat-label>
      <input
        currencyMask
        class="sideText"
        name="Ex-GST"
        matInput
        type="text"
        formControlName="ESTIMATEFROMTOTALINCGST"
        (keyup)="calcPI('min')"
        [(ngModel)]="PRICEVALGST"
        matTooltip="{{ toolTipList ? toolTipList.ESTIMATEFROMTOTALINCGST?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      @if (testBool && toolTipList.ESTIMATEFROMTOTALINCGST) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.ESTIMATEFROMTOTALINCGST.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.ESTIMATEFROMTOTALINCGST?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
      <!-- <span class="currency_sign" matPrefix>$&nbsp;</span> -->
    </mat-form-field>
  </div>

  @if (AllowEstimateRange) {
    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
      <mat-form-field
        appearance="outline"
        class="example"
        fxFlex="59"
        class="pr-1"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.ESTIMATEFROMTOTALEXGST),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.ESTIMATEFROMTOTALEXGST),
        }"
      >
        <mat-label>Estimate Maximum Ex-GST</mat-label>
        <input
          class="sideText"
          currencyMask
          matInput
          type="text"
          formControlName="MAXESTIMATEFROMTOTALEXGST"
          (keyup)="calcPE('max')"
          [(ngModel)]="MAXPRICEVAL"
          matTooltip="{{ toolTipList ? toolTipList.ESTIMATEFROMTOTALEXGST?.HOVER : '' }}"
          [matTooltipPosition]="toolTipPostion"
        />
        <!-- <span class="currency_sign" matPrefix>$&nbsp;</span> -->
        @if (testBool && toolTipList.ESTIMATEFROMTOTALEXGST) {
          <div class="tooltip-wrap">
            <input
              id="myInput"
              readonly
              disabled
              value="{{ toolTipList ? toolTipList.ESTIMATEFROMTOTALEXGST.COPYVALUE : '' }}"
            />
            <mat-icon
              (click)="
                tooltipService.copyTooltipText(
                  toolTipList
                    ? $safeNavigationMigration(toolTipList?.ESTIMATEFROMTOTALEXGST?.COPYVALUE)
                    : ''
                )
              "
            >
              file_copy
            </mat-icon>
          </div>
        }
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        fxFlex="50"
        class="pr-1"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.PRICEVALGST),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PRICEVALGST),
        }"
      >
        <mat-label>Estimate Maximum Inc-GST</mat-label>
        <input
          currencyMask
          class="sideText"
          name="maxEx-GST"
          matInput
          type="text"
          formControlName="MAXESTIMATEFROMTOTALINCGST"
          (keyup)="calcPI('max')"
          [(ngModel)]="MAXPRICEVALGST"
          matTooltip="{{ toolTipList ? toolTipList.ESTIMATETOTOTALINCGST?.HOVER : '' }}"
          [matTooltipPosition]="toolTipPostion"
        />
        <!-- <span class="currency_sign" matPrefix>$&nbsp;</span> -->
        @if (testBool && toolTipList.ESTIMATETOTOTALINCGST) {
          <div class="tooltip-wrap">
            <input
              id="myInput"
              readonly
              disabled
              value="{{ toolTipList ? toolTipList.ESTIMATETOTOTALINCGST.COPYVALUE : '' }}"
            />
            <mat-icon
              (click)="
                tooltipService.copyTooltipText(
                  toolTipList
                    ? $safeNavigationMigration(toolTipList?.ESTIMATETOTOTALINCGST.COPYVALUE)
                    : ''
                )
              "
            >
              file_copy
            </mat-icon>
          </div>
        }
      </mat-form-field>
    </div>
  }
  <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <!-- <mat-form-field appearance="outline" fxFlex="100" [ngClass]="{'has-error':errorWarningData.Error?.NOTES,'has-warning':errorWarningData.Warning?.NOTES}">
        <mat-label>Notes</mat-label>
        <textarea matInput formControlName="NOTES"  matTooltip="{{(toolTipList)?toolTipList.NOTES?.HOVER:''}}" [matTooltipPosition]="toolTipPostion" (keyup)="onKeyPressTextMessage($event)" id="notesData"></textarea>
        <div  *ngIf="testBool && toolTipList.NOTES" class="tooltip-wrap" ><input id="myInput" readonly disabled value="{{(toolTipList)?toolTipList.NOTES.COPYVALUE:''}}"><mat-icon (click)="tooltipService.copyTooltipText((toolTipList)?toolTipList?.NOTES.COPYVALUE:'')">file_copy</mat-icon></div>
      </mat-form-field> -->
    <mat-form-field
      appearance="outline"
      class="full-width pr-1"
      fxFlex="100"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData?.Error?.NOTES),
        'has-warning': $safeNavigationMigration(errorWarningData?.Warning?.NOTES),
      }"
    >
      <mat-label>Notes</mat-label>

      <textarea
        matInput
        formControlName="NOTES"
        [matTooltip]="toolTipList?.NOTES?.HOVER || ''"
        [matTooltipPosition]="toolTipPostion"
        (keyup)="onKeyPressTextMessage($event)"
        id="notesData"
        rows="4"
        cdkTextareaAutosize
        cdkAutosizeMinRows="3"
        cdkAutosizeMaxRows="10"
        (keydown.enter)="$event.stopImmediatePropagation()"
      ></textarea>
      @if (testBool && toolTipList.NOTES) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.NOTES.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.NOTES.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
</div>
